class PackBuilder {
  constructor(root) {
    this.root = root;

    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    this.routes = {
      root: window.Shopify.routes.root
    };

    this.products = this.getProducts();

    this.packSize = 1;

    this.packDiscounts = {
      1: Number(root.dataset.pack1discount || 0),
      2: Number(root.dataset.pack2discount || 0),
      3: Number(root.dataset.pack3discount || 0)
    };

    this.slots = {
      1: [],
      2: [],
      3: []
    };

    this.cache = new Map();
    this.cachePdpData = new Map();

    this.isAddingToCart = false;
    this.isBuyingNow = false;

    this.errorTimeout = null;

    this.init();
  }

  /*
   * ---------------------------------------------------------
   * INITIALIZATION
   * ---------------------------------------------------------
   */

  getProducts() {
    const element =
      this.root.querySelector('[data-pack-products]');

    if (!element) return [];

    try {
      return JSON.parse(element.textContent).products || [];
    } catch (error) {
      console.error(
        'Pack Builder: invalid product JSON',
        error
      );

      return [];
    }
  }

  async init() {
    this.bindEvents();

    try {
      // this.removeDefaultSelectedSize();

      await this.preloadCurrentProduct();

      this.renderPack(1);
      this.renderPack(2);
      this.renderPack(3);

      this.updateTotals();
      this.updateActivePack();

      await this.loadAllProducts();
      await this.loadAllPdpData();

    } catch (error) {
      console.error(
        'Pack Builder initialization failed:',
        error
      );
    }
  }

  /*
   * ---------------------------------------------------------
   * EVENTS
   * ---------------------------------------------------------
   */

  bindEvents() {
    this.root.addEventListener(
      'change',
      async (event) => {

        const colorSelect =
          event.target.closest('[data-pack-color]');

        if (colorSelect) {
          await this.handleColorChange(colorSelect);
          return;
        }

        const sizeSelect =
          event.target.closest(
            '[data-pack-size-select]'
          );

        if (sizeSelect) {
          this.handleSizeChange(sizeSelect);
          return;
        }

        const packInput =
          event.target.closest('[data-pack-size]');

        if (packInput) {

          const newPackSize =
            Number(packInput.value);

          if (![1, 2, 3].includes(newPackSize)) {
            return;
          }

          this.packSize = newPackSize;

          this.updateActivePack();
          this.updateTotals();

          return;
        }
      }
    );

    // Sync PDP size selection with Pack of 1 (Single)
    document.addEventListener('change', (event) => {
      const sizeInput = event.target.closest(
        'variant-selects .input_size'
      );

      if (!sizeInput || !sizeInput.checked) return;

      this.syncSinglePackSize(sizeInput.value);
    });

    /*
     * ADD TO CART
     */
    const addButton =
      this.root.querySelector('[data-pack-add]');

    addButton?.addEventListener(
      'click',
      () => {
        this.addPackToCart();
      }
    );

    /*
     * BUY IT NOW
     */
    const buyButton =
      this.root.querySelector('[data-pack-buy]');

    buyButton?.addEventListener(
      'click',
      () => {
        this.buyPackNow();
      }
    );
  }

  /*
   * ---------------------------------------------------------
   * PRODUCT LOADING
   * ---------------------------------------------------------
   */

  async preloadCurrentProduct() {
    const currentHandle =
      this.root.dataset.currentHandle;

    if (!currentHandle) return;

    await this.loadProduct(currentHandle);
  }

  async loadProduct(handle) {
    if (!handle) {
      throw new Error(
        'Product handle is missing.'
      );
    }

    if (this.cache.has(handle)) {
      return this.cache.get(handle);
    }

    const response = await fetch(
      `${this.routes.root}products/${encodeURIComponent(handle)}.js`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Unable to load product: ${handle}`
      );
    }

    const product =
      await response.json();

    this.cache.set(handle, product);

    return product;
  }

  async loadAllProducts() {
    try {
        await Promise.all(
            this.products.map(product => this.loadProduct(product.handle))
        );
    } catch (error) {
      console.error(
        'Pack loadAllProducts failed:',
        error
      );
    }
  }

  async loadAllPdpData() {
    try {
        await Promise.all(
            this.products.map(async (product) => {
    
            const currentGallery =
                document.querySelector(
                '.product__media-wrapper'
                );
    
            if (!currentGallery) {
                return;
            }
    
            const productSection =
                currentGallery.closest(
                '[id^="shopify-section-"]'
                );
    
            if (!productSection) {
                return;
            }
            const sectionId =
                productSection.id.replace(
                'shopify-section-',
                ''
                );
    
            const cachedProduct =
                this.cache.get(product.handle);
    
            if (!cachedProduct) {
                return;
            }
    
            const productData =
                this.cachePdpData.get(product.handle);
    
            if (productData) {
                return;
            }        
    
            const response =
                await fetch(
                `${product.url}?sections=${encodeURIComponent(
                    sectionId
                )}`
                );
    
            if (!response.ok) {
                throw new Error(
                'Gallery request failed'
                );
            }
    
            const sections =
                await response.json();
    
            const html =
                sections[sectionId];
    
            this.cachePdpData.set(product.handle, html);
            
            })
        );
    } catch (error) {
      console.error(
        'Pack loadAllPdpData failed:',
        error
      );
    }
  }

  /*
   * ---------------------------------------------------------
   * PACK RENDERING
   * ---------------------------------------------------------
   */

  renderPack(packSize) {
    const container =
      this.root.querySelector(
        `[data-pack-slots="${packSize}"]`
      );

    if (!container) return;

    container.innerHTML = `<p class="options-heading">Select Your Options</p>`;

    for (
      let index = 0;
      index < packSize;
      index++
    ) {
      const slot =
        this.createSlot(
          packSize,
          index
        );

      container.appendChild(slot);
    }
  }

  createSlot(packSize, index) {
    const wrapper =
      document.createElement('div');

    wrapper.className =
      'pack-slot';

    wrapper.dataset.slotIndex =
      index;

    wrapper.dataset.packSize =
      packSize;

    wrapper.innerHTML = `
      <div class="pack-slot__number">
        ${index + 1}
      </div>

      <div class="pack-slot__product">

        <div class="pack-slot__image">
          <img
            data-pack-image
            alt=""
            loading="lazy"
          >
        </div>

        <div class="pack-select--wrapper">
            <label>Color</label>
            <select
            class="pack-select"
            data-pack-color
            aria-label="Select color"
            name="pack-select-color"
            >
            ${this.products
                .map(product => `
                <option
                    value="${this.escapeAttribute(
                    product.handle
                    )}"
                >
                    ${this.escapeHTML(
                    product.color
                    )}
                </option>
                `)
                .join('')}
            </select>
            <svg aria-hidden="true" focusable="false" class="icon-caret" viewBox="0 0 10 6">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
            </path></svg>
        </div>

        <div class="pack-select--wrapper">
            <label>Size</label>
            <select
            class="pack-select"
            data-pack-size-select
            aria-label="Select size"
            name="pack-select-size"
            >
            <option value="">
                Select size
            </option>
            </select>
            <svg aria-hidden="true" focusable="false" class="icon-caret" viewBox="0 0 10 6">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
            </path></svg>
        </div>

      </div>
    `;

    const colorSelect =
      wrapper.querySelector(
        '[data-pack-color]'
      );

    const firstProduct =
      this.products[0];

    const currentHandle =
      this.root.dataset.currentHandle;

    if (currentHandle) {
        colorSelect.value =
        currentHandle;

      /*
       * Don't await here because createSlot()
       * itself isn't async.
       */
      this.setSlotProduct(
        wrapper,
        currentHandle
      );
    } else if (firstProduct) {

      colorSelect.value =
        firstProduct.handle;

      /*
       * Don't await here because createSlot()
       * itself isn't async.
       */
      this.setSlotProduct(
        wrapper,
        firstProduct.handle
      );
    }

    return wrapper;
  }

  async setSlotProduct(
    slotElement,
    handle
  ) {
    try {

      const product =
        await this.loadProduct(handle);

      slotElement.dataset.productHandle =
        handle;

      slotElement.dataset.productId =
        product.id;

      /*
       * Store family information if available.
       *
       * This expects your product JSON data to optionally
       * contain a family value.
       */
      if (product.family) {
        slotElement.dataset.productFamily =
          product.family;
      }

      const image =
        slotElement.querySelector(
          '[data-pack-image]'
        );

      if (image) {

        image.src =
          this.getProductImage(product);

        image.alt =
          product.title || '';
      }

      const sizeSelect =
        slotElement.querySelector(
          '[data-pack-size-select]'
        );

      if (!sizeSelect) {
        return;
      }

      sizeSelect.innerHTML = '';

      const sizes =
        this.getSizeOption(product);

      if (!sizes.length) {

        const option =
          document.createElement('option');

        option.value = '';
        option.textContent =
          'Size unavailable';

        sizeSelect.appendChild(option);

      } else {

        /*
         * Placeholder
         */
        /*
        const placeholder =
          document.createElement('option');

        placeholder.value = '';
        placeholder.textContent =
          'Select size';

        sizeSelect.appendChild(
          placeholder
        );
        */

        sizes.forEach(size => {

          const option =
            document.createElement(
              'option'
            );

          option.value =
            size.value[0];

          option.textContent =
            size.value[0];

          if(size.value[1] === false) {
            option.disabled = true;
          }

          sizeSelect.appendChild(
            option
          );
        });
      }

      /*
       * Automatically select the first available size.
       */
      /*
      const firstAvailable =
        product.variants.find(
          variant =>
            variant.available
        );

      if (firstAvailable) {

        const sizeValue =
          this.getVariantSize(
            product,
            firstAvailable
          );

        sizeSelect.value =
          sizeValue || '';
      }
      */
    
      /**
       * Default size selection logic:
       *
       * Pack 1:
       * 1. Try to use the currently selected PDP size.
       * 2. If unavailable, fall back to the first available size.
       *
       * Pack 2 and Pack 3:
       * Always use the first available size by default.
       */

      const isSinglePack =
        Number(slotElement.dataset.packSize) === 1 &&
        Number(slotElement.dataset.slotIndex) === 0;

      const preferredSize = isSinglePack
        ? this.getSelectedPdpSize()
        : '';

      let selectedVariant = null;

      // First preference: PDP-selected size (Single only).
      if (preferredSize) {
        selectedVariant = product.variants.find(
          variant =>
            variant.available &&
            this.getVariantSize(product, variant) === preferredSize
        );
      }

      // Fallback: first available variant.
      if (!selectedVariant) {
        selectedVariant = product.variants.find(
          variant => variant.available
        );
      }

      if (selectedVariant) {
        const sizeValue = this.getVariantSize(
          product,
          selectedVariant
        );

        sizeSelect.value = sizeValue || '';
      }

      this.updateSlotVariant(slotElement);

      this.updateTotals();

    } catch (error) {

      console.error(
        'Pack Builder: unable to set slot product',
        error
      );

      this.showError(
        'Unable to load the selected product.'
      );
    }
  }

  /*
   * ---------------------------------------------------------
   * SIZE / VARIANT HANDLING
   * ---------------------------------------------------------
   */

  getSizeOption(product) {
    if (
      !product.options ||
      !product.variants
    ) {
      return [];
    }

    const sizeOptionIndex =
      product.options.findIndex(
        option =>
          option.name &&
          option.name
            .toLowerCase() === 'size'
      );

    if (sizeOptionIndex === -1) {
      return [];
    }

    const values =
      new Set();

    product.variants.forEach(
      variant => {

        // if (!variant.available) {
        //   return;
        // }
        const available = variant.available;

        const value =
          variant.options[
            sizeOptionIndex
          ];

        if (value) {
          values.add([value, available]);
        }
      }
    );

    return [
      ...values
    ].map((value) => ({
      value
    }));
  }

  getVariantSize(
    product,
    variant
  ) {
    const sizeOptionIndex =
      product.options.findIndex(
        option =>
          option.name &&
          option.name
            .toLowerCase() === 'size'
      );

    if (sizeOptionIndex === -1) {
      return '';
    }

    return (
      variant.options[
        sizeOptionIndex
      ] || ''
    );
  }

  async handleColorChange(select) {
    const slot =
      select.closest('.pack-slot');

    if (!slot) return;

    const handle =
      select.value;

    if (!handle) {
      return;
    }

    await this.setSlotProduct(
      slot,
      handle
    );

    /*
     * Update Dawn main product gallery
     * to the selected sibling product.
     */
    await this.updateMainGallery(
      handle
    );

    this.updateTotals();
  }

  /*
  handleSizeChange(select) {
    const slot =
      select.closest('.pack-slot');

    if (!slot) return;

    this.updateSlotVariant(
      slot
    );

    this.updateTotals();
  }
  */

  handleSizeChange(select) {
    const slot =
      select.closest('.pack-slot');

    if (!slot) return;

    this.updateSlotVariant(slot);

    /*
    * Pack of 1 → PDP Size
    *
    * Only Pack of 1 / Single should
    * control the main PDP size.
    */
    const isSinglePack =
      Number(slot.dataset.packSize) === 1 &&
      Number(slot.dataset.slotIndex) === 0;

    if (isSinglePack && select.value) {
      this.syncPdpSizeFromSinglePack(
        select.value
      );
    }

    this.updateTotals();
  }

  updateSlotVariant(slot) {
    const handle =
      slot.dataset.productHandle;

    if (!handle) {
      return;
    }

    const product =
      this.cache.get(handle);

    if (!product) {
      return;
    }

    const sizeSelect =
      slot.querySelector(
        '[data-pack-size-select]'
      );

    const size =
      sizeSelect?.value;

    const sizeIndex =
      product.options.findIndex(
        option =>
          option.name &&
          option.name
            .toLowerCase() === 'size'
      );

    const variant =
      product.variants.find(
        candidate => {

        //   if (!candidate.available) {
        //     return false;
        //   }

          /*
           * Product has no Size option.
           */
          if (sizeIndex === -1) {
            return true;
          }

          return (
            candidate.options[
              sizeIndex
            ] === size
          );
        }
      );

    if (!variant) {

      slot.dataset.variantId =
        '';

      slot.dataset.variantPrice =
        '';

      return;
    }

    slot.dataset.variantId =
      String(variant.id);

    slot.dataset.variantPrice =
      String(variant.price);

    const image =
      slot.querySelector(
        '[data-pack-image]'
      );

    if (
      image &&
      variant.featured_image &&
      variant.featured_image.src
    ) {
      image.src =
        variant.featured_image.src;
    }
  }

  /*
   * ---------------------------------------------------------
   * PRICE
   * ---------------------------------------------------------
   */

  updateTotals() {
    [2, 3].forEach(
      packSize => {

        const container =
          this.root.querySelector(
            `[data-pack-slots="${packSize}"]`
          );

        const priceElement =
          this.root.querySelector(
            `[data-pack-total="${packSize}"]`
          );

        if (
          !container ||
          !priceElement
        ) {
          return;
        }

        const packSave =
          this.root.querySelector(
            `[data-pack-option="${packSize}"] .pack-save`
          );

        const slots = [
          ...container.querySelectorAll(
            '.pack-slot'
          )
        ];

        const total =
          slots.reduce(
            (sum, slot) => {

              return (
                sum +
                Number(
                  slot.dataset.variantPrice ||
                  0
                )
              );

            },
            0
          );

        const discount =
          Math.max(
            0,
            Math.min(
              100,
              Number(
                this.packDiscounts[
                  packSize
                ] || 0
              )
            )
          );

        const discountedTotal =
          total *
          (1 - discount / 100);

        if (
          discount <= 0
        ) {

          priceElement.textContent =
            this.formatMoney(
              total
            );

          if (packSave) {
            packSave.style.display =
              'none';
          }

        } else {

          priceElement.innerHTML = `
            ${this.formatMoney(
              discountedTotal
            )}
            <span class="small original-pack-price">
              ${this.formatMoney(
                total
              )}
            </span>
          `;

          if (packSave) {

            packSave.style.display =
              '';

            packSave.textContent =
              `You saved ${this.formatMoney(
                total - discountedTotal
              )}`;
          }
        }
      }
    );
  }

  /*
   * ---------------------------------------------------------
   * DAWN GALLERY
   * ---------------------------------------------------------
   */

  async updateMainGallery(handle) {
    try {

      const currentGallery =
        document.querySelector(
          '.product__media-wrapper'
        );

      const currentProductModal =
        document.querySelector(
          '.product-media-modal.media-modal'
        );

      if (!currentGallery) {
        return;
      }

      const productSection =
        currentGallery.closest(
          '[id^="shopify-section-"]'
        );

      if (!productSection) {
        return;
      }

      const sectionId =
        productSection.id.replace(
          'shopify-section-',
          ''
        );

      const product =
        this.cache.get(handle);

      if (!product) {
        return;
      }

      const pdpData = this.cachePdpData.get(handle);

      let html = null;
      let sections = null;

      if (!pdpData) {
        const response =
            await fetch(
            `${product.url}?sections=${encodeURIComponent(
                sectionId
            )}`
            );

        if (!response.ok) {
            throw new Error(
            'Gallery request failed'
            );
        }

        sections =
            await response.json();

        html =
            sections[sectionId];
      } else {
        html = pdpData;
      }

      if (!html) {
        return;
      }

      const parser =
        new DOMParser();

      const parsed =
        parser.parseFromString(
          html,
          'text/html'
        );

      const newGallery =
        parsed.querySelector(
          '.product__media-wrapper'
        );

      const newProductModal =
        parsed.querySelector(
          '.product-media-modal.media-modal'
        );

      if (!newGallery) {
        return;
      }

      currentGallery.replaceWith(
        newGallery
      );

      enableZoomOnHover(2);

      if (currentProductModal && newProductModal) {
        currentProductModal.replaceWith(
            newProductModal
        );
      }

    } catch (error) {

      console.error(
        'Pack Builder gallery update failed:',
        error
      );
    }
  }

  /*
   * ---------------------------------------------------------
   * PACK BUILDER
   * ---------------------------------------------------------
   *
   * This is shared by:
   *
   * - Add To Cart
   * - GoKwik Buy Now
   *
   * This prevents the two buttons from using
   * different validation logic.
   */

  buildPack() {

    const packSize =
      Number(this.packSize);

    if (
      ![1, 2, 3].includes(packSize)
    ) {

      return {
        valid: false,
        error:
          'Please select a valid pack.'
      };
    }

    const container =
      this.root.querySelector(
        `[data-pack-slots="${packSize}"]`
      );

    if (!container) {

      return {
        valid: false,
        error:
          `Pack of ${packSize} is unavailable.`
      };
    }

    const slots = [
      ...container.querySelectorAll(
        '.pack-slot'
      )
    ];

    if (
      slots.length !== packSize
    ) {

      return {
        valid: false,
        error:
          `Pack of ${packSize} is not configured correctly.`
      };
    }

    const variants =
      slots.map(
        (slot, index) => {

          return {
            slot,
            slotIndex: index + 1,
            id: Number(
              slot.dataset.variantId
            ),
            handle:
              slot.dataset.productHandle,
            productId:
              slot.dataset.productId,
            family:
              slot.dataset.productFamily ||
              ''
          };
        }
      );

    /*
     * Every slot must have a variant.
     */
    const missing =
      variants.some(
        item =>
          !Number.isInteger(item.id) ||
          item.id <= 0
      );

    if (missing) {

      return {
        valid: false,
        error:
          `Please select all ${packSize} products and sizes.`
      };
    }

    /*
     * Prevent exact duplicate variants.
     */
    /*
    const ids =
      variants.map(
        item => item.id
      );

    const duplicate =
      ids.some(
        (id, index) =>
          ids.indexOf(id) !== index
      );

    if (duplicate) {

      return {
        valid: false,
        error:
          'Please select different products or sizes.'
      };
    }
      */

    /*
     * Product family.
     *
     * If your product JSON does not currently provide
     * family, this will simply be skipped.
     *
     * We can connect this directly to your actual
     * sibling metafield once its namespace/key is known.
     */
    const families =
      [
        ...new Set(
          variants
            .map(item => item.family)
            .filter(Boolean)
        )
      ];

    if (
      families.length > 1
    ) {

      return {
        valid: false,
        error:
          'Selected products cannot be combined in this pack.'
      };
    }

    /*
     * Generate one ID for the entire pack.
     */
    const packId =
      this.createPackId();

    return {
      valid: true,

      id: packId,

      size: packSize,

      family:
        families[0] || '',

      variants
    };
  }

  createPackId() {

    if (
      window.crypto &&
      typeof window.crypto.randomUUID ===
        'function'
    ) {

      return `MM-${window.crypto.randomUUID()}`;
    }

    return (
      `MM-${Date.now()}-` +
      Math.random()
        .toString(36)
        .slice(2, 10)
    );
  }

  /*
   * ---------------------------------------------------------
   * ADD TO CART
   * ---------------------------------------------------------
   */

  async addPackToCart() {

    if (
      this.isAddingToCart ||
      this.isBuyingNow
    ) {
      return;
    }

    const pack =
      this.buildPack();

    if (!pack.valid) {

      this.showError(
        pack.error
      );

      return;
    }

    const items =
      this.buildCartItems(
        pack
      );

    const button =
      this.root.querySelector(
        '[data-pack-add]'
      );

    this.isAddingToCart =
      true;

    if (button) {
      button.disabled =
        true;

      button.classList.add(
        'is-loading'
      );
    }

    const sections = [
      'cart-drawer',
      'cart-icon-bubble',
      'cart-live-region-text'
    ];

    try {

      const response =
        await fetch(
          `${this.routes.root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              items,

              sections:
                sections.join(','),

              sections_url:
                window.location.pathname
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add pack.'
        );
      }

      /*
       * Refresh Dawn cart UI.
       */
      if (
        this.cart &&
        typeof this.cart.renderContents ===
          'function'
      ) {

        this.cart.renderContents(
          data
        );

        if (
          this.cart.classList.contains(
            'is-empty'
          )
        ) {
          this.cart.classList.remove(
            'is-empty'
          );
        }

      } else {

        /*
         * Fallback for stores where the
         * cart drawer isn't available.
         */
        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh'
          )
        );
      }

      document.dispatchEvent(
        new CustomEvent(
          'pack:added',
          {
            detail: {
              data,
              pack
            }
          }
        )
      );

    } catch (error) {

      console.error(
        'Pack Builder Add To Cart failed:',
        error
      );

      this.showError(
        error.message ||
        'Unable to add pack to cart.'
      );

    } finally {

      this.isAddingToCart =
        false;

      if (button) {

        button.disabled =
          false;

        button.classList.remove(
          'is-loading'
        );
      }
    }
  }

  /*
   * ---------------------------------------------------------
   * CART ITEM BUILDER
   * ---------------------------------------------------------
   */

  buildCartItems(pack) {

    return pack.variants.map(
      item => {

        const properties = {

          /*
           * Underscore properties are hidden
           * from normal Shopify cart rendering.
           */
          '_pack_id':
            pack.id,

          '_pack_size':
            String(pack.size),

          '_pack_type':
            `Pack of ${pack.size}`,

          '_pack_slot':
            String(item.slotIndex)
        };

        if (pack.family) {

          properties[
            '_pack_family'
          ] =
            String(pack.family);
        }

        return {
          id: item.id,

          quantity: 1,

          properties
        };
      }
    );
  }

  /*
   * ---------------------------------------------------------
   * GOKWIK BUY NOW
   * ---------------------------------------------------------
   *
   * IMPORTANT:
   *
   * We DO NOT:
   *
   * - redirect to /checkout
   * - click #gokwik-buy-now
   * - manually open a GoKwik iframe
   * - manually clear the cart
   *
   * We pass the complete pack to GoKwik's
   * own Buy Now handler.
   */

  async buyPackNow() {

    if (
      this.isAddingToCart ||
      this.isBuyingNow
    ) {
      return;
    }

    const pack =
      this.buildPack();

    if (!pack.valid) {

      this.showError(
        pack.error
      );

      return;
    }

    /*
     * Confirm GoKwik is available.
     */
    if (
      typeof window.onBuyNowClick !==
        'function'
    ) {

      this.showError(
        'GoKwik checkout is still loading. Please try again.'
      );

      console.error(
        '[Pack Builder] GoKwik onBuyNowClick is unavailable.'
      );

      return;
    }

    const button =
      this.root.querySelector(
        '[data-pack-buy]'
      );

    if (!button) {

      this.showError(
        'Buy Now button was not found.'
      );

      return;
    }

    this.isBuyingNow =
      true;

    this.setBuyNowLoading(
      true
    );

    /*
     * GoKwik's own normalizeBuyNowProducts()
     * accepts:
     *
     * {
     *   id,
     *   quantity,
     *   properties
     * }
     *
     * Therefore we intentionally use the same
     * structure as the Shopify cart items.
     */
    const products =
      this.buildCartItems(
        pack
      );

    try {

      /*
       * This is the important integration:
       *
       * custom button
       *        +
       * complete Pack 2/3 products
       *        ↓
       * GoKwik
       */
      window.onBuyNowClick(
        button,
        false,
        products
      );

    } catch (error) {

      console.error(
        '[Pack Builder] GoKwik Buy Now failed:',
        error
      );

      this.showError(
        error.message ||
        'Unable to start GoKwik checkout.'
      );

      this.setBuyNowLoading(
        false
      );

      this.isBuyingNow =
        false;
    }

    /*
     * GoKwik itself keeps its button loading
     * state for approximately 3 seconds.
     *
     * We release our lock after that.
     */
    setTimeout(
      () => {

        this.setBuyNowLoading(
          false
        );

        this.isBuyingNow =
          false;

      },
      3500
    );
  }

  /*
   * ---------------------------------------------------------
   * GOKWIK LOADING UI
   * ---------------------------------------------------------
   */

  setBuyNowLoading(
    loading
  ) {

    const button =
      this.root.querySelector(
        '[data-pack-buy]'
      );

    if (!button) {
      return;
    }

    button.disabled =
      loading;

    button.classList.toggle(
      'is-loading',
      loading
    );

    const text =
      button.querySelector(
        '[data-buy-now-text]'
      );

    if (text) {

      text.textContent =
        loading
          ? 'PROCESSING...'
          : 'BUY IT NOW';
    }
  }

  /*
   * ---------------------------------------------------------
   * ACTIVE PACK
   * ---------------------------------------------------------
   */

  updateActivePack() {

    this.root
      .querySelectorAll(
        '[data-pack-option]'
      )
      .forEach(
        option => {

          option.classList.toggle(
            'is-active',
            Number(
              option.dataset.packOption
            ) === this.packSize
          );
        }
      );
  }

  /*
   * ---------------------------------------------------------
   * ERROR
   * ---------------------------------------------------------
   */

  showError(message) {

    const error =
      this.root.querySelector(
        '[data-pack-error]'
      );

    if (!error) {
      console.error(
        '[Pack Builder]',
        message
      );

      return;
    }

    error.textContent =
      message;

    error.hidden =
      false;

    clearTimeout(
      this.errorTimeout
    );

    this.errorTimeout =
      setTimeout(
        () => {

          error.hidden =
            true;

        },
        4000
      );
  }

  /*
   * ---------------------------------------------------------
   * HELPERS
   * ---------------------------------------------------------
   */

  getProductImage(product) {

    if (
      !product.featured_image
    ) {
      return '';
    }

    return product.featured_image;
  }

  formatMoney(cents) {

    const amount =
      Number(cents || 0) / 100;

    return new Intl.NumberFormat(
      document.documentElement.lang ||
        'en-IN',
      {
        style: 'currency',

        currency:
          Shopify.currency?.active ||
          'INR',

        maximumFractionDigits:
          2
      }
    ).format(amount);
  }

  escapeHTML(value) {

    const div =
      document.createElement(
        'div'
      );

    div.textContent =
      value;

    return div.innerHTML;
  }

  escapeAttribute(value) {
    return this.escapeHTML(
      value
    );
  }

  /*
  removeDefaultSelectedSize() {
    const productInfoWrapper = this.root.closest('.product__info-wrapper');

    if(productInfoWrapper) {
        const allInputs = productInfoWrapper.querySelectorAll('variant-selects input');
        if(allInputs.length > 0) {
            allInputs.forEach(e => {
                e.checked = false;
            })
        }
    }
  }
  */

  /**
   * Get currently selected size from the main PDP.
   */
  getSelectedPdpSize() {
    const selectedSize = document.querySelector(
      'variant-selects .input_size:checked'
    );

    return selectedSize?.value || '';
  }


  /**
   * Sync PDP size with Pack of 1 (Single).
   *
   * Only updates the first slot of Pack 1.
   * Pack 2 and Pack 3 remain independent.
   */
  syncSinglePackSize(size) {
    if (!size) return;

    const singleContainer = this.root.querySelector(
      '[data-pack-slots="1"]'
    );

    if (!singleContainer) return;

    const singleSlot = singleContainer.querySelector(
      '.pack-slot'
    );

    if (!singleSlot) return;

    const sizeSelect = singleSlot.querySelector(
      '[data-pack-size-select]'
    );

    if (!sizeSelect) return;

    // Find matching size in the Single pack.
    const matchingOption = Array.from(
      sizeSelect.options
    ).find(option => option.value === size);

    // Do not select unavailable sizes.
    if (!matchingOption || matchingOption.disabled) {
      return;
    }

    sizeSelect.value = size;

    // Update variant ID, price and image.
    this.updateSlotVariant(singleSlot);

    this.updateTotals();
  }

  /**
   * Sync Pack of 1 (Single) size with the main PDP size.
   *
   * Pack 1 → PDP
   */
  syncPdpSizeFromSinglePack(size) {
    if (!size) return;

    const sizeInput = Array.from(
      document.querySelectorAll(
        'variant-selects .input_size'
      )
    ).find(input =>
      input.value === size
    );

    if (!sizeInput) {
      return;
    }

    /*
    * Already selected.
    */
    if (sizeInput.checked) {
      return;
    }

    /*
    * Select the matching PDP size.
    */
    sizeInput.checked = true;

    /*
    * Trigger the native change event so
    * Dawn's variant-selects component
    * updates the actual product variant.
    */
    sizeInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }
}


/*
 * ---------------------------------------------------------
 * INITIALIZE
 * ---------------------------------------------------------
 */

document.querySelectorAll('[data-pack-builder]').forEach(element => {
    new PackBuilder(element);
});